<template>
	<li class="list-group-item store-list-item">
		<label v-if="canAddFavoriteMark" class="stock-favorite" :title="favoriteTitle">
			<input type="checkbox" v-model="inUserSelection"><span />
		</label>
		<span v-else class="stock-favorite" />
		<a-link class="store-info" :to="storeRoute">
			<span>
				{{ store.name }}
				<span v-if="store.isPickupPoint" class="store-pickup-point">
					Pick-Up Point
				</span>
				<span v-if="showDistance && store.dist">
					({{ formatDistance(store.dist) }})
				</span>
			</span>
			<!-- Address -->
			<span class="store-location">
				<template  v-if="mq.current >= mq.md"> {{ store.address }}, </template>
				{{ store.city }}
			</span>
			<!-- Open hours, abnormal open hours -->
			<is-store-open :store="store" />
		</a-link>
	</li>
</template>
<script>
import mq from 'mediaQuery';
import { formatDistance, standardRoute } from 'utils';
import { t } from 'datastore/i18n';
import { mapState } from 'vuex';


export default {
	props: {
		showDistance: {
			type: Boolean,
			default: true,
		},
		showOpenHours: {
			type: Boolean,
			default: true,
		},
		store: {
			type: Object,
			required: true,
		},
	},
	data () {
		return {
			mq,
			formatDistance,
		};
	},
	methods: {
		ts: t.prefix('STOCK'),
	},
	computed: {
		favoriteMarkCount () {
			return this.$store.state.userSettings.myStores.length;
		},
		favoriteTitle () {
			return this.ts('STAR');
		},
		canAddFavoriteMark () {
			if (this.store.id === 9999) { // @TODO övriga butiker, övergå till att använda strängar
				return false;
			}
			return ! (isNaN(this.store.id) || (this.favoriteMarkCount >= 3 && ! this.inUserSelection));
		},
		lineHeightStyle () {
			return mq.current < mq.md ? { lineHeight: '1.0' } : {};
		},
		storeRoute () {
			return standardRoute('store', { id: this.store.id, name: this.store.name });
		},
		inUserSelection: {
			get () {
				return this.$store.state.userSettings.myStores.indexOf(this.store.id) >= 0;
			},
			set (checked) {
				const index = this.$store.state.userSettings.myStores.indexOf(this.store.id);
				if (checked && index < 0) {
					this.$store.dispatch('userSettings/addStore', this.store.id);
				} else if (! checked && index >= 0) {
					this.$store.dispatch('userSettings/removeStore', this.store.id);
				}
			},
		},
		...mapState({
			userSettings: state => state.userSettings
		}),
	},
};
</script>